import { Component, AfterViewInit, Output, EventEmitter, ViewEncapsulation, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Message } from '../../../models/message.model';
import { AbstractComponent } from '../../../commons/abstract.component';

@Component({
    selector: 'app-google-maps-view',
    // templateUrl: './google-maps-view.component.html',
    templateUrl: './google-maps-view.v2.component.html',
    styleUrls: ['./google-maps-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GoogleMapsViewComponent extends AbstractComponent implements AfterViewInit {

  center: google.maps.LatLngLiteral = { lat: -15.83897, lng: -48.027201 };
  zoom = 15;
  display: google.maps.LatLngLiteral;
  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: google.maps.LatLngLiteral[] = [{ lat: -15.83897, lng: -48.027201 }];

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<GoogleMapsViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Message,
  ) {
    super(injector);
    if (data && data.metadata.place) {
      this.center = { lat: data.metadata.place.location.latitude, lng: data.metadata.place.location.longitude };
      this.markerPositions = [{ lat: data.metadata.place.location.latitude, lng: data.metadata.place.location.longitude }];
    }
  }

  ngAfterViewInit(): void {
  }

  moveMap(event: google.maps.MapMouseEvent) {
    this.center = (event.latLng.toJSON());
  }

  move(event: google.maps.MapMouseEvent) {
    this.display = event.latLng.toJSON();
  }

  displayAddress(suggestion: any): string {
    return suggestion ? suggestion.formattedAddress : '';
  }

  close(): void {
    this.dialogRef.close();
  }

  openInNewTab() {
    const encodedLabel = encodeURIComponent(this.data.content || 'Localização');
    const url = `https://www.google.com/maps?q=${this.markerPositions[0].lat},${this.markerPositions[0].lng}(${encodedLabel})`;
    window.open(url, '_blank');
  }

  copyContent() {
    const encodedLabel = encodeURIComponent(this.data.content || 'Localização');
    const curlContent = `https://www.google.com/maps?q=${this.markerPositions[0].lat},${this.markerPositions[0].lng}(${encodedLabel})`;
    navigator.clipboard.writeText(curlContent).then(() => {
      this.alertService.info('Link de localização copiado com sucesss!')
    }, (err) => {
      console.error('Erro ao copiar o conteúdo:', err);
    });
  }

}
